import { api } from '@/api'
import type { ApiResponse } from '@/api/typings/response.typing'

export interface UserLrfmResponse {
  id: number
  user_id: number
  lifetime: string
  recency: string
  frequency: number
  average_transaction_value: string
  monetary_value_currency: string
  monetary_value_rial: string
  monetary_volume_currency: string
  monetary_volume_rial: string
  last_updated: string
  created_at: string
}

export function getUserLrfmAction(userUuid: string): Promise<ApiResponse<UserLrfmResponse>> {
  return api.get<ApiResponse<UserLrfmResponse>>(`/lrfms/user/${userUuid}`)
}
